import React from 'react';
import PropTypes from 'prop-types';

function Tag(props) {
  const { children, title, checked, onClick } = props;
  const classes = `inline-flex items-center rounded-md px-2 py-1 text-xs font-medium inset-ring inset-ring-orange-600/20 cursor-pointer ${checked ? 'bg-sunrise text-white active' : 'bg-orange-50 text-sunrise'}`;

  return (
    <div data-test={`tag-${children}`} className={classes} onClick={onClick} title={title}>
      {children}
    </div>
  );
}

Tag.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Tag;
